import { VisitorEmailPolicy } from "helpers/constants";

export const VISITOR_EMAIL_POLICIES_OPTIONS = [
  {
    label: "visitorEmailPolicy.none",
    value: VisitorEmailPolicy.None,
  },
  {
    label: "visitorEmailPolicy.internal_only",
    value: VisitorEmailPolicy.InternalOnly,
    description: "visitorEmailPolicy.internal_only_description",
  },
  {
    label: "visitorEmailPolicy.internal_and_external",
    value: VisitorEmailPolicy.InternalAndExternal,
    description: "visitorEmailPolicy.internal_and_external_description",
  },
];
